module.exports = __webpack_public_path__ + "img/logo-on-voucher.b1157b52.png";